/* renewal.js：新しいページの動き（仕上げ計画の4〜6章）。動かすのは opacity と transform だけ。動きを減らす設定のときは、移動をやめて不透明度だけにする。 */
(function () {
  var d = document, w = window, de = d.documentElement;
  var rm = !!(w.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in w;
  var ROOT = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T_ADD = 'カートに入れる', T_SOLD = '売り切れ';
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function raf2(f) { requestAnimationFrame(function () { requestAnimationFrame(f); }); }

  /* iOS で :active を効かせる */
  d.addEventListener('touchstart', function () {}, { passive: true });

  /* ヘッダーの影：ページの一番上の目印が見えなくなったら出す */
  var hd = $('.rn-hd'), top = $('.rn-top');
  if (hd) {
    if (top && hasIO) {
      new IntersectionObserver(function (en) { hd.classList.toggle('is-scrolled', !en[0].isIntersecting); }).observe(top);
    } else {
      var onS = function () { hd.classList.toggle('is-scrolled', w.pageYOffset > 4); };
      w.addEventListener('scroll', onS, { passive: true }); onS();
    }
  }

  /* メニュー */
  var menu = $('#rn-menu'), opener = $('[data-rn-menu="open"]'), bk = d.createElement('div');
  bk.className = 'rn-bk';
  if (menu) { d.body.appendChild(bk); if (menu.parentNode !== d.body) d.body.appendChild(menu); }
  var lockY = 0, locked = false;
  function lock(on) {
    var s = d.body.style;
    if (on && !locked) {
      lockY = w.pageYOffset; locked = true; de.style.scrollBehavior = 'auto';
      s.overflow = 'hidden'; s.position = 'fixed'; s.top = -lockY + 'px'; s.left = '0'; s.right = '0'; s.width = '100%';
    } else if (!on && locked) {
      locked = false; s.overflow = s.position = s.top = s.left = s.right = s.width = '';
      w.scrollTo(0, lockY); setTimeout(function () { de.style.scrollBehavior = ''; }, 50);
    }
  }
  function isOpen() { return !!menu && menu.classList.contains('is-open'); }
  function setMenu(o, noFocus) {
    if (!menu || o === isOpen()) return;
    /* 開くとき、メニューの上端をヘッダーの上端にそろえる。お知らせの帯が見えていても、×が☰と同じ位置に来る */
    if (o) { var ht = hd ? Math.max(0, Math.round(hd.getBoundingClientRect().top)) : 0; menu.style.top = ht ? ht + 'px' : ''; }
    menu.classList.toggle('is-open', o); bk.classList.toggle('is-open', o); lock(o);
    if (opener) opener.setAttribute('aria-expanded', o ? 'true' : 'false');
    if (o) {
      var f = $('ul a', menu);
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    } else if (opener && !noFocus) opener.focus({ preventScroll: true });
  }
  if (menu) {
    d.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-rn-menu]');
      if (t) { e.preventDefault(); setMenu(t.getAttribute('data-rn-menu') === 'open'); return; }
      if (e.target === bk) setMenu(false);
    });
    d.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { setMenu(false); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled])', menu);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = d.activeElement;
      if (!menu.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });
    var x0 = null, y0 = 0;
    menu.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    menu.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = Math.abs(t.clientY - y0);
      x0 = null;
      if (dx < -60 && dy < 40) setMenu(false);
    }, { passive: true });
    var mqW = matchMedia('(min-width:1280px)');
    var onW = function () { if (mqW.matches) setMenu(false, true); };
    if (mqW.addEventListener) mqW.addEventListener('change', onW); else if (mqW.addListener) mqW.addListener(onW);
  }

  /* 節の表示：画面の下にある節だけ、入ってきたときに 250ms で出す */
  (function () {
    if (rm || !hasIO || navigator.webdriver || /[?&]rn_static=1/.test(location.search)) return;
    var secs = $$('main .rn-sec, main .rn-sec--band').filter(function (s) {
      var p = s.parentElement && s.parentElement.closest('.rn-sec, .rn-sec--band');
      return !p && s.getBoundingClientRect().top > w.innerHeight;
    });
    if (!secs.length) return;
    var seen = false;
    function showAll() { secs.forEach(function (s) { s.classList.add('is-in'); }); }
    var io = new IntersectionObserver(function (en) {
      seen = true;
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    secs.forEach(function (s) { s.classList.add('rn-rv'); io.observe(s); });
    setTimeout(function () { if (!seen) showAll(); }, 1500);
    w.addEventListener('beforeprint', showAll);
  })();

  /* 画像：読み込みが終わってから 300ms で出す（先に読む主画像は除く） */
  $$('main img:not([fetchpriority])').forEach(function (i) {
    if (i.complete || i.classList.contains('rn-ov')) return;
    i.classList.add('rn-img');
    var ok = function () { i.classList.add('is-ld'); };
    i.addEventListener('load', ok, { once: true }); i.addEventListener('error', ok, { once: true });
  });

  /* 折りたたみ：開くときは高さと不透明度、閉じるときは逆の順に */
  if (!rm) {
    $$('.rn-faq').forEach(function (box) {
      box.classList.add('rn-x');
      $$('details', box).forEach(function (dt) {
        var a = $('.rn-a', dt), sm = $('summary', dt), tm = 0;
        if (!a || !sm) return;
        if (dt.open) dt.classList.add('is-open');
        function done() { clearTimeout(tm); a.removeEventListener('transitionend', onEnd); if (!dt.classList.contains('is-open')) dt.open = false; }
        function onEnd(e) { if (e.target === a) done(); }
        sm.addEventListener('click', function (e) {
          e.preventDefault();
          if (dt.classList.contains('is-open')) {
            dt.classList.remove('is-open');
            a.addEventListener('transitionend', onEnd); tm = setTimeout(done, 300);
          } else {
            clearTimeout(tm); a.removeEventListener('transitionend', onEnd);
            dt.open = true; raf2(function () { dt.classList.add('is-open'); });
          }
        });
        /* ページ内検索などで開いたとき */
        dt.addEventListener('toggle', function () {
          if (dt.open && !dt.classList.contains('is-open')) raf2(function () { if (dt.open) dt.classList.add('is-open'); });
          else if (!dt.open) dt.classList.remove('is-open');
        });
      });
    });
  }

  /* 数量の＋− */
  function num(i, k, def) { var v = parseInt(i.getAttribute(k), 10); return isNaN(v) ? def : v; }
  function stepSync(wr) {
    var i = wr && $('input', wr); if (!i) return;
    var dec = $('[data-rn-step="dec"]', wr), v = parseInt(i.value, 10);
    if (dec) dec.disabled = !(v > num(i, 'data-min', 1));
  }
  $$('.rn-step').forEach(stepSync);
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rn-step]');
    if (!b) return;
    var wr = b.closest('.rn-step'), i = wr && $('input', wr);
    if (!i) return;
    var mn = num(i, 'data-min', 1), mx = num(i, 'data-max', 9999), v = parseInt(i.value, 10);
    if (isNaN(v)) v = mn;
    v = Math.max(mn, Math.min(mx, v + (b.getAttribute('data-rn-step') === 'inc' ? 1 : -1)));
    if (String(v) !== i.value) {
      i.value = v;
      if (!rm) { i.classList.remove('is-tick'); void i.offsetWidth; i.classList.add('is-tick'); }
      i.dispatchEvent(new Event('change', { bubbles: true }));
    }
    stepSync(wr);
  });
  d.addEventListener('input', function (e) {
    var i = e.target;
    if (i.matches && i.matches('.rn-step input')) { var c = i.value.replace(/[^0-9]/g, ''); if (c !== i.value) i.value = c; }
  });
  d.addEventListener('change', function (e) {
    var i = e.target;
    if (!(i.matches && i.matches('.rn-step input'))) return;
    var mn = num(i, 'data-min', 1), mx = num(i, 'data-max', 9999), v = parseInt(i.value, 10);
    if (isNaN(v) || v < mn) i.value = mn; else if (v > mx) i.value = mx;
    stepSync(i.closest('.rn-step'));
  }, true);

  /* カート：数量を変えたら 0.5 秒待って反映する */
  var cf = d.getElementById('rn-cart-form');
  if (cf) {
    var ct = 0;
    d.addEventListener('change', function (e) {
      if (!(e.target.matches && e.target.matches('[data-rn-qty]'))) return;
      clearTimeout(ct);
      ct = setTimeout(function () { cf.setAttribute('aria-busy', 'true'); cf.submit(); }, 500);
    });
  }

  /* 情報提供のフォーム：送ったあとはお礼の文へ移る */
  var fok = d.getElementById('rn-form-ok');
  if (fok) setTimeout(function () { fok.focus(); }, 0);

  /* ここから商品ページ */
  var form = d.getElementById('rn-pdp-form');
  if (!form) return;
  var ctas = $$('.rn-cta', form), lbls = $$('[data-rn-lbl]', form), cta = $('[data-rn-cta]', form);
  var idIn = $('input[name=id]', form), bar = $('[data-rn-sticky]');
  var go = $('[data-rn-go]', form), err = $('[data-rn-err]', form), stat = $('[data-rn-status]', form);
  var soldNow = !!(cta && cta.disabled), busy = false, doneT = 0;

  /* 固定の「カートに入れる」：本来のボタンが画面の上へ出たら出す */
  if (cta && bar && hasIO) {
    new IntersectionObserver(function (en) {
      bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(cta);
  }

  function withW(u, wd) {
    try {
      var x = new URL(u, location.href);
      x.searchParams.delete('width'); x.searchParams.set('width', wd);
      return x.href;
    } catch (e) { return u; }
  }

  /* ギャラリー */
  var g = $('.rn-gal'), th = $('.rn-thumbs'), galw = $('.rn-galw');
  var pg = $('[data-rn-pg]'), pt = $('[data-rn-pt]'), gc = $('[data-rn-gc]');
  var kids = g ? [].slice.call(g.children) : [], tbs = [], cur = 0, prevT = 0;
  var mqPC = matchMedia('(min-width:960px)');
  function mark(i) {
    cur = i;
    tbs.forEach(function (b, j) { if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    if (pg) pg.textContent = i + 1;
    if (gc) gc.classList.toggle('is-off', i !== 0);
  }
  function show(i, fromScroll) {
    if (!g || !kids.length) return;
    i = Math.max(0, Math.min(kids.length - 1, i));
    if (mqPC.matches) {
      if (i !== cur) {
        var old = kids[cur];
        kids.forEach(function (k) { k.classList.remove('is-prev'); });
        old.classList.add('is-prev'); old.classList.remove('is-cur');
        kids[i].classList.add('is-cur');
        clearTimeout(prevT);
        prevT = setTimeout(function () { old.classList.remove('is-prev'); }, rm ? 150 : 260);
      }
    } else if (!fromScroll) {
      g.scrollTo({ left: kids[i].offsetLeft - kids[0].offsetLeft, behavior: rm ? 'auto' : 'smooth' });
    }
    mark(i);
  }
  if (g && kids.length) {
    g.classList.add('is-js');
    kids[0].classList.add('is-cur');
    if (pt) pt.textContent = kids.length;
    if (kids.length < 2) {
      if (th) th.hidden = true;
      if (galw) galw.classList.add('is-one');
      var gcn = $('.rn-gcount'); if (gcn) gcn.hidden = true;
    } else if (th) {
      kids.forEach(function (k, i) {
        var b = d.createElement('button'), src = '';
        b.type = 'button'; b.setAttribute('aria-label', '写真' + (i + 1) + 'を表示');
        var im = k.tagName === 'IMG' ? k : $('img:not(.rn-ov)', k);
        if (im) {
          var t = d.createElement('img'); t.alt = ''; t.width = 72; t.height = 72; t.loading = 'lazy'; t.decoding = 'async';
          t.src = withW(im.getAttribute('data-rn-src') || im.currentSrc || im.getAttribute('src') || '', 160); b.appendChild(t);
        } else {
          var m = (k.textContent || '').match(/#\d+/); b.textContent = m ? m[0] : '枠';
        }
        b.addEventListener('click', function () { show(i); });
        b.addEventListener('keydown', function (e) {
          var n = { ArrowUp: -1, ArrowLeft: -1, ArrowDown: 1, ArrowRight: 1 }[e.key];
          if (!n) return;
          e.preventDefault();
          var j = Math.max(0, Math.min(kids.length - 1, i + n));
          show(j); tbs[j].focus();
        });
        th.appendChild(b); tbs.push(b);
      });
    }
    g.addEventListener('keydown', function (e) {
      if (!mqPC.matches) return;
      var n = { ArrowLeft: -1, ArrowRight: 1 }[e.key];
      if (n) { e.preventDefault(); show(cur + n); }
    });
    if (hasIO && kids.length > 1) {
      var gio = new IntersectionObserver(function (en) {
        if (mqPC.matches) return;
        en.forEach(function (x) { if (x.isIntersecting) mark(kids.indexOf(x.target)); });
      }, { root: g, threshold: 0.6 });
      kids.forEach(function (k) { gio.observe(k); });
    }
    var onMQ = function () {
      kids.forEach(function (k, j) { k.classList.toggle('is-cur', j === cur); k.classList.remove('is-prev'); });
      if (!mqPC.matches) g.scrollLeft = kids[cur].offsetLeft - kids[0].offsetLeft;
    };
    if (mqPC.addEventListener) mqPC.addEventListener('change', onMQ); else if (mqPC.addListener) mqPC.addListener(onMQ);
    mark(0);
  }

  /* 写真の3枚目から：スマホでは、写真を横に動かすか、写真の欄に入るまで読まない。PC ではすぐ読む（機種別の調整） */
  (function () {
    var lz = g ? $$('img[data-rn-src]', g) : [];
    if (!lz.length) return;
    var go = function () {
      if (!lz.length) return;
      lz.forEach(function (im) {
        var ss = im.getAttribute('data-rn-srcset');
        if (ss) im.setAttribute('srcset', ss);
        im.setAttribute('src', im.getAttribute('data-rn-src'));
        im.removeAttribute('data-rn-srcset'); im.removeAttribute('data-rn-src');
      });
      lz = [];
    };
    if (mqPC.matches) { go(); return; }
    g.addEventListener('scroll', go, { passive: true, once: true });
    g.addEventListener('focusin', go, { once: true });
    g.addEventListener('touchstart', go, { passive: true, once: true });
    var onPC = function () { if (mqPC.matches) go(); };
    if (mqPC.addEventListener) mqPC.addEventListener('change', onPC); else if (mqPC.addListener) mqPC.addListener(onPC);
  })();

  /* 色のイメージ（テーマ B のみ。data-img があるときだけ主写真を替える） */
  var tok = 0;
  function colorImg(r) {
    var nm = r.getAttribute('data-name') || '', src = r.getAttribute('data-img');
    /* 色ごとの写真がないとき（A と、B の画像アップロード前）は、札は写真の色のまま変えない */
    if (!src || !kids.length) return;
    if (gc) gc.textContent = nm + (r.getAttribute('data-img-l') === '1' ? '（色のイメージ）' : '');
    var box = kids[0], base = $('img:not(.rn-ov)', box);
    if (!base) return;
    var my = ++tok, alt = r.getAttribute('data-alt') || base.alt;
    show(0);
    if (base.getAttribute('data-rn-src') === src) { base.alt = alt; return; }
    var set = [480, 768, 1000].map(function (x) { return withW(src, x) + ' ' + x + 'w'; }).join(', ');
    var ov = new Image();
    ov.className = 'rn-ov'; ov.alt = ''; ov.setAttribute('aria-hidden', 'true');
    ov.sizes = base.sizes; ov.srcset = set; ov.src = withW(src, 1000);
    function put() {
      if (my !== tok) return;
      box.appendChild(ov);
      raf2(function () { ov.classList.add('is-in'); });
      setTimeout(function () {
        if (my !== tok) { ov.remove(); return; }
        base.srcset = set; base.src = withW(src, 1000); base.alt = alt; base.setAttribute('data-rn-src', src);
        var fin = function () { $$('.rn-ov', box).forEach(function (o) { if (o === ov || my === tok) o.remove(); }); };
        (base.decode ? base.decode() : Promise.resolve()).then(fin, fin);
      }, rm ? 160 : 270);
      if (tbs[0]) { var ti = $('img', tbs[0]); if (ti) ti.src = withW(src, 160); }
    }
    (ov.decode ? ov.decode() : Promise.resolve()).then(put, put);
  }

  /* 色のイメージを先に読む（テーマ B だけ。色見本に指やマウスが近づいたときに1回）。初めて色を選んだときも、待たずに重ねて出せる */
  var swBox = form && $('.rn-sw', form);
  if (swBox && $('input[data-img]', swBox)) {
    var preDone = false;
    var pre = function () {
      if (preDone) return; preDone = true;
      var b0 = kids.length ? $('img:not(.rn-ov)', kids[0]) : null;
      $$('input[data-img]', swBox).forEach(function (r) {
        var s = r.getAttribute('data-img');
        if (!s || (b0 && b0.getAttribute('data-rn-src') === s)) return;
        var im = new Image();
        if (b0 && b0.sizes) im.sizes = b0.sizes;
        im.srcset = [480, 768, 1000].map(function (x) { return withW(s, x) + ' ' + x + 'w'; }).join(', ');
        im.src = withW(s, 1000);
      });
    };
    ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) { swBox.addEventListener(ev, pre, { passive: true, once: true }); });
  }

  /* 色・種類を選んだとき */
  function pick(r) {
    if (!r) return;
    if (idIn) idIn.value = r.value;
    var nm = r.getAttribute('data-name'), pr = r.getAttribute('data-price'), st = r.getAttribute('data-st') || 'stock';
    if (nm) $$('[data-rn-color]').forEach(function (n) { n.textContent = nm; });
    if (pr) $$('[data-rn-price]').forEach(function (n) { n.textContent = pr; });
    $$('.rn-ntcs__i').forEach(function (n) { n.classList.toggle('is-on', n.getAttribute('data-rn-st') === st); });
    soldNow = st === 'sold';
    lbls.forEach(function (l) { l.textContent = soldNow ? T_SOLD : T_ADD; });
    ctas.forEach(function (b) { b.disabled = soldNow; b.classList.remove('is-done'); });
    try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(history.state, '', u.href); } catch (e) {}
    if (r.type === 'radio') colorImg(r);
  }
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'rn-variant') pick(t);
    else if (t.hasAttribute && t.hasAttribute('data-rn-sel')) pick(t.options[t.selectedIndex]);
  });

  /* カートに入れる */
  function count(n) {
    var c = $('.rn-cartn'), l = $('.rn-cartl');
    if (c) {
      c.textContent = n; c.hidden = n < 1;
      if (!rm) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    }
    if (l) l.setAttribute('aria-label', 'カート（' + n + '点）');
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (soldNow || busy) return;
    busy = true;
    ctas.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    if (err) err.hidden = true;
    if (stat) stat.textContent = '';
    var fd = new FormData(form);
    fd.delete('rn-variant');
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) { var er = new Error('add'); er.j = x.j; throw er; }
        ctas.forEach(function (b) { b.classList.add('is-done'); });
        clearTimeout(doneT);
        doneT = setTimeout(function () { ctas.forEach(function (b) { b.classList.remove('is-done'); }); }, 2000);
        if (go) go.classList.add('is-on');
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) { count(c.item_count); if (stat) stat.textContent = 'カートに入れました。カートの商品は' + c.item_count + '点です。'; })
          .catch(function () { if (stat) stat.textContent = 'カートに入れました。'; });
      })
      .catch(function (er) {
        if (!err) return;
        var p = $('p', err), ds = er && er.j && er.j.description;
        if (p) {
          p.innerHTML = '<b>カートに入れられませんでした。</b>';
          p.appendChild(d.createTextNode(typeof ds === 'string' && ds ? ds : '通信の状態を確かめて、もう一度お試しください。'));
        }
        err.hidden = false;
      })
      .then(function () { busy = false; ctas.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  });
  /* 戻るで表示し直したとき */
  w.addEventListener('pageshow', function (e) {
    if (e.persisted) { busy = false; ctas.forEach(function (b) { b.classList.remove('is-done'); b.removeAttribute('aria-busy'); }); }
  });
})();
